import React from "react";
import { DetailMovies, FavoriteFilm, Movie } from "./pages";
import NavigationBar from "./components/NavigationBar";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <Router>
          <NavigationBar></NavigationBar>
          <Switch>
            <Route exact path="/" component={Movie}></Route>
            <Route
              exact
              path="/detailMovie/:title"
              component={DetailMovies}
            ></Route>
            <Route exact path="/favoriteFilm" component={FavoriteFilm}></Route>
          </Switch>
        </Router>
      </div>
    </Provider>
  );
}

export default App;
